export interface ReqResponse {
    success: boolean;
    message: string;
    error?: string;
    data?: any;
    ref_id?: string;
    response_code?: number;
}